<mulo-horizontaller verticalAlign="center" [rtl]="i18nService.isLangRtl()">
  @for (relation of relations(); track relation) {
    <mulo-horizontaller-item
      class="margin-right-sm"
      >
      <exl-citation-brief
        [title]="limitTitle(relation.relatedAssetTitle)"
        [titleClickable]="true"
        [titleUrl]="getRelationTitleURL(relation)"
        >
        <ng-container slot="pre-title">
          {{'research.portal.relation.asset.' + relation.relationType |
          translate}}
          <span style="width: 0; display: inline-block;">
            <mat-icon svgIcon="arrow-down" muloSvgViewbox></mat-icon>
          </span>
        </ng-container>
      </exl-citation-brief>
    </mulo-horizontaller-item>
  }
</mulo-horizontaller>
